import React from "react";
import "./FlowerAnimation.css";

const FlowerAnimation = () => {
  return (
    <div className="falling-flowers">
      {[...Array(25)].map((_, i) => (
        <span key={i} className="flower">🌸</span>
      ))}
    </div>
  );
};

export default FlowerAnimation;
